import Log from '@deephaven/log';
import React, { Component } from 'react';
import LoadingOverlay from "./LoadingOverlay.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('ErrorBoundary');
/**
 * Error boundary for catching render errors in React. Displays an error message if an error is caught by default, or you can specify a fallback component to render.
 * https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 */
export class ErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      error: undefined
    };
  }
  componentDidCatch(error, errorInfo) {
    var onError = this.props.onError;
    log.error('Error caught by ErrorBoundary', error, errorInfo);
    onError === null || onError === void 0 || onError(error, errorInfo);
  }
  render() {
    var _this$props = this.props,
      children = _this$props.children,
      className = _this$props.className,
      fallback = _this$props.fallback;
    var error = this.state.error;
    if (error != null) {
      if (fallback != null) {
        return fallback;
      }
      return /*#__PURE__*/_jsx("div", {
        className: className,
        children: /*#__PURE__*/_jsx(LoadingOverlay, {
          errorMessage: "".concat(error),
          isLoading: false,
          isLoaded: false,
          "data-testid": "error-boundary-loading"
        })
      });
    }

    // We need to check for undefined children because React will throw an error if we return undefined from a render method
    // Note this behaviour was changed in React 18: https://github.com/reactwg/react-18/discussions/75
    return children !== null && children !== void 0 ? children : null;
  }
}
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map